<template>
  <div class="chat-member-avatar">
    <div v-if="isOwner">
      <vs-avatar v-if="mode === 'chat-head'"
        size="40px"
        class="chat-avatar-image border-solid m-0 flex-shrink-0 sm:mr-4 mr-4 ml-1 shadow-md border-primary"
        :src="userImg(member.photo)"></vs-avatar>
    </div>

    <div v-else>
      <vx-tooltip v-if="member" :text="member.fullname">
        <vs-avatar
          class="chat-avatar-image border-solid m-0 flex-shrink-0 sm:mr-2 mr-2 shadow-md "
          :class="{ 'border-success': mode === 'chat-head', 'border-2': member.active, 'border-white' : !member.active }"
          :src="userImg(member.photo)"></vs-avatar>
      </vx-tooltip>

      <vx-tooltip v-else text="Unknown Member">
        <vs-avatar
          class="border-2 border-solid border-grey m-0 flex-shrink-0 sm:mr-2 mr-2 opacity-50"
          :src="userImg('')"
        ></vs-avatar>
      </vx-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    member: {
      type: Object,
      default: null
    },
    mode: {
      type: String,
      default: null
    },
    isOwner: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      publicProfile: null
    }
  },
  computed: {
    userImg() {
      return (imageUUID) => {
        if (imageUUID) {
          return process.env.VUE_APP_FILE_SERVER + "/" + imageUUID;
        }
        return "";
      }
      // return (userUUID) => {
      //   if (!userUUID) {
      //     return ""
      //   }
      //   return ""
      //   // if (isSentByActiveUser) return this.$store.state.AppActiveUser.photoURL
      //   // else return this.$store.getters['chat/contact'](this.userId).photoURL
      // }
    },
  },
  // methods: {
  //   async getPublicProfile(userUUID) {
  //     // Get Public Profile (Display Image and Name)
  //     // by using user uuid
  //     const publicProfile = await this.$store.dispatch("User/getPublicProfile", { userUUID });
  //     if (publicProfile) {
  //       this.publicProfile = publicProfile;
  //     }
  //   }
  // },
  // async mounted() {
  //   if (this.member && this.member.uuid) {
  //     await this.getPublicProfile();
  //   }
  // }
}
</script>

<style lang="scss">
.chat-member-avatar {
  max-height: 40px;
  height: auto;

  & .chat-avatar-image {
    border-color: white;
  }
}
</style>